/**
 * Section bodies are Markdown with two extensions produced by the generator:
 *   [[c1]]                      a citation marker  -> rendered as a clickable chip
 *   ![caption](frame:<uuid>)    a screenshot       -> resolved to a signed image URL
 */
const MARKER_RE = /\[\[(c\d+)\]\]/g;

/** Turn citation markers into ordinary Markdown links with a cite: scheme that the renderer intercepts. */
export function withCitationLinks(body: string): string {
  return body.replace(MARKER_RE, (_m, id: string) => `[${id}](cite:${id})`);
}

const SAFE_PROTOCOLS = new Set(['http:', 'https:', 'mailto:', 'cite:', 'frame:']);

/** react-markdown urlTransform: keeps our custom schemes, drops anything script-capable such as javascript:. */
export function safeUrl(url: string): string {
  const m = /^([a-zA-Z][a-zA-Z0-9+.-]*:)/.exec(url.trim());
  if (!m) return url; // relative or fragment
  return SAFE_PROTOCOLS.has(m[1].toLowerCase()) ? url : '';
}

export function citationIdFromHref(href?: string): string | null {
  return href && href.startsWith('cite:') ? href.slice('cite:'.length) : null;
}

export function frameIdFromSrc(src?: string): string | null {
  return src && src.startsWith('frame:') ? src.slice('frame:'.length) : null;
}

/**
 * Only a screenshot of the source video may be shown. Section text comes from a model that read an untrusted
 * transcript, so a remote image could be steered in to ping a third party from the reader's browser.
 */
export function isAllowedImageSrc(src?: string): boolean {
  return !!src && src.startsWith('frame:');
}
